import styled from 'styled-components';
import { alpha } from 'utils/ui';
import { borderValue } from 'styles/mixins';
import { getBreakpoint, headerBackgroundColor, getCheckboxColumnWidth } from '../utils';
import { withTableContext } from './TableContext';
import { tableCellBaseStyles, tableCellPropFilter } from './TableCell';
var TableRowHeader = withTableContext(styled.th.attrs(function () {
  return {
    role: 'rowheader',
    scope: 'row'
  };
}).withConfig({
  shouldForwardProp: tableCellPropFilter
}).withConfig({
  displayName: "TableRowHeader",
  componentId: "sc-1x0azoi-0"
})(["", " @media (max-width:", "){order:-1;display:flex;align-items:center;font-weight:bold;margin-bottom:", ";border-bottom:", ";", " tr[aria-selected] &&{padding-left:", ";}tr[data-highlighted] &&,tr[data-highlighted]:focus-within &&{background-color:", ";}tr[aria-selected='true'] &&,tr[aria-selected='true'][data-highlighted] &&{background-color:", ";}}"], tableCellBaseStyles, getBreakpoint('mobileViewBreakpoint'), function (p) {
  return p.theme.globals.spacing.xs;
}, function (p) {
  return borderValue(p.theme);
}, headerBackgroundColor, getCheckboxColumnWidth, function (p) {
  return alpha(p.theme.links, Math.max(0.05, +p.theme.shadeStrength / 2));
}, function (p) {
  return alpha(p.theme.links, Math.max(0.15, +p.theme.shadeStrength));
}));
TableRowHeader.displayName = 'TableRowHeader';
export default TableRowHeader;